import { Builder } from '@builder.io/react';

import UnstyledPhoneLink from './unstyled-phone-link';

Builder.registerComponent(UnstyledPhoneLink, {
  name: 'UnstyledPhoneLink',
  noWrap: true,
  inputs: [
    {
      name: 'includeTTY',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Include TTY',
    },
  ],
});
